import { usePage } from "@tree-company/tree-query";
import SurveyNavigation from "./survey_navigation";

export default function SheetPage({
  page,
  handleSave,
  onPreviousPage,
  children,
}) {
  const { title } = usePage(page);

  return (
    <form action="" className="survey" onSubmit={handleSave}>
      <div className="sheet">
        <h1 className="sheet__title">{title}</h1>
        <div className="sheet__content">{children}</div>
      </div>
      {page.settings.showNavigation && (
        <SurveyNavigation onPreviousPage={onPreviousPage} />
      )}
    </form>
  );
}
